
import React, { useEffect, useState } from 'react';
import CookieConsent from './CookieConsent';
import CookiePreferencesButton from './CookiePreferencesButton';
import { useCookieConsent } from '../hooks/useCookieConsent';

const ConsentManager = ({ children }) => {
  const { consent, hasConsent, isLoaded } = useCookieConsent();
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  useEffect(() => {
    // Listen for cookie settings open event
    const handleOpenCookieSettings = () => {
      setShowCookieSettings(true);
    };

    window.addEventListener('openCookieSettings', handleOpenCookieSettings);
    
    return () => {
      window.removeEventListener('openCookieSettings', handleOpenCookieSettings);
    };
  }, []);

  useEffect(() => {
    if (!isLoaded) return;

    // Initialize services based on consent
    if (hasConsent('analytics')) {
      loadAnalytics();
    }

    if (hasConsent('marketing')) {
      loadMarketing();
    }

    if (hasConsent('functional')) {
      loadFunctional();
    }
  }, [consent, isLoaded]);

  const loadAnalytics = () => {
    // Example: Load Google Analytics
    if (!window.gtag && hasConsent('analytics')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=GA_MEASUREMENT_ID';
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          window.dataLayer.push(arguments);
        }
        window.gtag = gtag;
        
        gtag('js', new Date());
        gtag('consent', 'default', {
          'analytics_storage': 'granted',
          'ad_storage': 'denied',
          'ad_user_data': 'denied',
          'ad_personalization': 'denied'
        });
      };
    }
  };

  const loadMarketing = () => {
    // Example: Load marketing pixels
    console.log('🎯 Marketing tools loaded');
    
    // Facebook Pixel example
    // if (hasConsent('marketing') && !window.fbq) {
    //   !function(f,b,e,v,n,t,s)
    //   {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    //   n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    //   if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    //   n.queue=[];t=b.createElement(e);t.async=!0;
    //   t.src=v;s=b.getElementsByTagName(e)[0];
    //   s.parentNode.insertBefore(t,s)}(window, document,'script',
    //   'https://connect.facebook.net/en_US/fbevents.js');
    //   fbq('init', 'YOUR_PIXEL_ID');
    //   fbq('track', 'PageView');
    // }
  };

  const loadFunctional = () => {
    // Example: Load chat widgets, preference cookies
    console.log('⚙️ Functional cookies loaded');
  };

  return (
    <>
      {children}
      <CookieConsent />
      <CookiePreferencesButton />
    </>
  );
};

export default ConsentManager;
